import { __assign } from 'tslib';
import { useCallback } from 'react';
import { noop } from '../../../utils/noop.esm.js';
import '@popperjs/core';
import { useToastDispatch } from '../ToastContext.esm.js';
import { toastActions } from '../types.esm.js';

var defaultState = { dispatch: noop };
/**
 * Use to display a toast message, remove a toast, clear all toasts, or get the current toasts.
 *
 * In tests make sure to render ToastProvider if you want to see the messages you send.
 */
function useToast() {
    var _a;
    var dispatch = ((_a = useToastDispatch()) !== null && _a !== void 0 ? _a : defaultState).dispatch;
    var toast = useCallback(function (text, options) {
        if (options === void 0) { options = {}; }
        dispatch({ type: toastActions.add, payload: __assign({ text: text }, options) });
    }, [dispatch]);
    var remove = useCallback(function (id) {
        dispatch({ type: toastActions.remove, payload: id });
    }, [dispatch]);
    var clear = useCallback(function () {
        dispatch({ type: toastActions.clear });
    }, [dispatch]);
    return {
        toast: toast,
        remove: remove,
        clear: clear
    };
}

export { useToast };
//# sourceMappingURL=useToast.esm.js.map
